// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"530e38db","453":"fc57318f","553":"a8b944c7"}[chunkId] + ".chunk.js";
};